import type { TreeItem } from '../components/tree/treeMapper'
import { StorageNodeTypeEnum } from '@d/sdk'
import { isViewModeAllowed } from '@d/util'

export function treeFilter(item: TreeItem[], cond: (treeItem: TreeItem) => boolean): TreeItem[] {
  const items: TreeItem[] = []
  for (const i of item) {
    if (i.children) {
      i.children = treeFilter(i.children, cond)
      items.push(i)
    }
    else {
      if (cond(i)) {
        items.push(i)
      }
    }
  }
  return items
}

export function viewModeFilter(treeItem: TreeItem, selected: string): boolean {
  if (treeItem.type === StorageNodeTypeEnum.Directory) {
    return true
  }
  if (treeItem.fullPath === selected) {
    return true
  }
  if (!treeItem.mime)
    return false
  return isViewModeAllowed(treeItem.mime, false)
}
